import { useState, useEffect } from 'react';
import setDetailData from '../services/setDetailData';

const useApiCall = (api, id = null) => {
  const [isLoading, setIsLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState(null);

  const fetchApi = id => {
    setIsLoading(true);
    api(id)
      .then(result => {
        let optionData = setDetailData(result.data);
        // console.log(optionData);
        setIsLoading(false);
        setFetchedData(optionData);
      })
      .catch(() => {
        //eslint-disable-next-line
        // console.log(err);
        setIsLoading(false);
      });
  };

  const handleSubmit = id => {
    fetchApi(id);
  };

  const loadData = idRequest => {
    fetchApi(idRequest);
  };

  useEffect(() => {
    fetchApi(id);
    //eslint-disable-next-line
  }, []);

  return [isLoading, fetchedData, handleSubmit, loadData];
};

export default useApiCall;
